import React from 'react';
import styled from 'styled-components';
import type { ProductReviewHeaderModel } from 'autogen/swagger/all';
import RatingStars from 'components/generic/ratingStars';
import { toHtmlContent } from 'modules/helpers/strings';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 30px 0;
`;

const Rating = styled.div`
    display: flex;
    align-items: center;
    font-size: 24px;
    font-weight: bold;
    line-height: 1;
    margin-bottom: 5px;
`;

const AverageRating = styled.span`
    margin-right: 10px;
`;

const ReadMore = styled.a`
    display: block;
    font-weight: bold;
    text-decoration: underline;
    margin-top: 5px;
`;

export interface IReviewsPreview {
    model: ProductReviewHeaderModel;
}

function ReviewsPreview(props: IReviewsPreview): JSX.Element {
    const { model } = props;
    const { averageRating, percentRecommendText, readMoreText } = model;

    return (
        <Wrapper>
            <Rating>
                <AverageRating>{averageRating}</AverageRating>
                <RatingStars size="M" rating={averageRating} />
            </Rating>
            <div>{toHtmlContent(percentRecommendText)}</div>
            <ReadMore href="#anchorReviews" data-js="anchorlink">
                {readMoreText}
            </ReadMore>
        </Wrapper>
    );
}

export default ReviewsPreview;
